import React from "react";

type IconMaintenaceProps = {
  fillColor?: string;
  iconColor?: string;
  style?: React.CSSProperties;
};

export function IconMaintenaceNew({
  fillColor = "#FFD700",
  iconColor = "#B37400",
}: IconMaintenaceProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
    >
      <g clipPath="url(#clip0_20079_4039)">
        <rect y="0.5" width="40" height="40" rx="20" fill={fillColor} />
        <rect
          y="0.5"
          width="40"
          height="40"
          rx="20"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M20 29.5C21.1046 29.5 22 28.6046 22 27.5C22 26.3954 21.1046 25.5 20 25.5C18.8954 25.5 18 26.3954 18 27.5C18 28.6046 18.8954 29.5 20 29.5Z"
          fill={iconColor}
        />
        <path d="M18.25 11.5H21.75V23.5H18.25V11.5Z" fill={iconColor} />
      </g>
      <defs>
        <clipPath id="clip0_20079_4039">
          <rect y="0.5" width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconMaintenaceNewSize({
  fillColor = "#FFD700",
  iconColor = "#B37400",
  style,
}: IconMaintenaceProps) {
  const uniqueId = React.useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 40 41"
      fill="none"
      style={style}
    >
      <g clipPath={`url(#${uniqueId})`}>
        <rect y="0.5" width="40" height="40" rx="20" fill={fillColor} />
        <rect
          y="0.5"
          width="40"
          height="40"
          rx="20"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M20 29.5C21.1046 29.5 22 28.6046 22 27.5C22 26.3954 21.1046 25.5 20 25.5C18.8954 25.5 18 26.3954 18 27.5C18 28.6046 18.8954 29.5 20 29.5Z"
          fill={iconColor}
        />
        <path d="M18.25 11.5H21.75V23.5H18.25V11.5Z" fill={iconColor} />
      </g>
      <defs>
        <clipPath id={uniqueId}>
          <rect y="0.5" width="40" height="40" rx="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IconNotApplicableDash({
  fillColor = "#A9A9A9",
  dashColor = "white",
}: {
  fillColor?: string;
  dashColor?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 40 40"
      fill="none"
    >
      <circle cx="20" cy="20" r="20" fill={fillColor} />
      <rect x="12" y="19" width="16" height="2" rx="1" fill={dashColor} />
    </svg>
  );
}

export function IconNotApplicableDashInspection({
  fillColor = "#A9A9A9",
  dashColor = "white",
  size = 40,
}: {
  fillColor?: string;
  dashColor?: string;
  size?: number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
    >
      <circle cx="20" cy="20" r="20" fill={fillColor} />
      <rect x="12" y="19" width="16" height="2" rx="1" fill={dashColor} />
    </svg>
  );
}

export function IconNotApplicableDashPreview({
  fillColor = "#A9A9A9",
  dashColor = "white",
  className = "ml-15",
}: {
  fillColor?: string;
  dashColor?: string;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="38"
      viewBox="0 0 40 40"
      fill="none"
      className={className}
    >
      <circle cx="20" cy="20" r="20" fill={fillColor} />
      <rect x="12" y="19" width="16" height="2" rx="1" fill={dashColor} />
    </svg>
  );
}
